import { useMutation } from "@tanstack/react-query";
import { panelUpdate } from "common/api/unos_rad/unos_panel";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "constant/react_query";

type UseUnosPanelUpdateParams = {
  invalidateKeys?: string[];
};

export const useUnosPanelUpdate = (hookParams?: UseUnosPanelUpdateParams) => {
  const queryClient = useQueryClient();
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: panelUpdateMutate } = useMutation({
    mutationFn: async (params: any) =>
      await panelUpdate(params.id, params.updatePayload),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.UNOS_VIDEO_GET],
        });
      }
    },
  });

  return { panelUpdateMutate };
};
